import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const WHATSAPP_LINK =
  "https://wa.me/966540423401?text=Hello%20BlackRide%20%F0%9F%9A%98%0A%0AI%E2%80%99d%20like%20to%20book%20a%20ride.%0A%0APickup%3A%0ADrop%3A%0ADate%20%26%20Time%3A%0APassengers%3A%0A%0APlease%20confirm%20availability.";
const CALL_LINK = "tel:+966540423401";

const COPY = {
  en: {
    title: "Ready to Arrange Your Chauffeur Service?",
    text: "Message BlackRide with your route, date, timing, and preferred vehicle class to receive direct chauffeur coordination.",
    whatsapp: "Book on WhatsApp Now",
    call: "Call Now",
  },
  ar: {
    title: "جاهز لحجز رحلتك؟",
    text: "احصل على تأكيد فوري خلال دقائق. بدون انتظار. بدون تعقيد.",
    whatsapp: "احجز عبر واتساب الآن",
    call: "اتصل الآن",
  },
};

export default function CTASection() {
  const { lang } = useLanguage();
  const copy = COPY[lang] || COPY.en;

  return (
    <section id="cta" data-testid="cta-section" className="relative py-20 md:py-24 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[32px] overflow-hidden"
        >
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#261d08,transparent_40%),#111] border border-white/5 rounded-[32px]" />
          <div className="relative text-center py-16 md:py-20 px-6">
            <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-6 max-w-3xl mx-auto">
              {copy.title}
            </h2>
            <p className="text-base text-gray-300 mb-10 max-w-2xl mx-auto">{copy.text}</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#C7A239] hover:bg-[#D4B34A] text-black font-medium px-10 py-4 rounded-full transition-all duration-300"
                data-testid="final-whatsapp-cta"
                data-track="final_whatsapp_cta"
              >
                <MessageCircle className="w-5 h-5" />
                {copy.whatsapp}
              </a>
              <a
                href={CALL_LINK}
                className="inline-flex items-center justify-center gap-2 border border-white/20 hover:border-white text-white px-10 py-4 rounded-full text-sm font-medium transition-all duration-300 hover:bg-white/5"
                data-testid="final-call-cta"
                data-track="final_call_cta"
              >
                <Phone className="w-5 h-5" />
                {copy.call}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
